import { watch } from 'vue'
import { useRoute } from 'vue-router'
import { useSessionStore } from '@/stores/session'

function readSessionQuery(value: unknown): string {
  if (typeof value === 'string') return value.trim()
  if (Array.isArray(value)) {
    const first = value[0]
    return typeof first === 'string' ? first.trim() : ''
  }
  return ''
}

/** APP 内嵌 H5：从 URL ?session=xxx 同步登录态，需在发起业务请求前调用 */
export function useAppSessionFromQuery(options?: { onSessionUpdated?: () => void }) {
  const route = useRoute()
  const sessionStore = useSessionStore()

  function applySessionFromQuery(): boolean {
    const id = readSessionQuery(route.query.session)
    if (!id) return false

    const changed = sessionStore.sessionId !== id
    sessionStore.setSessionId(id)
    if (changed) {
      options?.onSessionUpdated?.()
    }
    return true
  }

  applySessionFromQuery()

  watch(
    () => route.query.session,
    () => {
      applySessionFromQuery()
    },
  )

  return { applySessionFromQuery }
}

export function getSessionIdFromQuery(query: Record<string, unknown>): string {
  return readSessionQuery(query.session)
}
